var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row fixed-bottom bg-light px-3 py-2 small"},[_c('div',{staticClass:"col"},[_vm._v("\n    "+_vm._s(_vm.version)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"col text-right"},[_c('mz-date-display',{attrs:{"timestamp":_vm.timestamp}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ec93d92","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Footer.vue
// module id = 319
// module chunks = 1